<template>
    <div class="faq-suggestion-basicpage">
        <div class="third-rea banji">
            <div class="third-btn">
                <div class="btn-left">检索条件</div>
                <div class="btn-right">
                    <el-button class="btn-two" type="primary" @click="search">查询</el-button>
                    <el-button class="btn-two" type="default" @click="reset('searchForm')">重置</el-button>
                    <span class="btn-shu"></span>
                    <el-button class="btn-four" type="default" icon="el-icon-search" @click="hignSearch">高级检索</el-button>
                </div>
            </div>
            <div class="third-search">
                <el-form :inline="true" :model="searchForm" label-width="76px" ref="searchForm">
                    <div class="search-row">
                        <div class="row-item">
                            <el-form-item label="建议人账号">
                                <el-input
                                    class="item-input"
                                    :maxlength="30"
                                    v-model.trim="searchForm.keyId"
                                    @keyup.enter.native="search"
                                    placeholder="请输入"
                                ></el-input>
                            </el-form-item>
                        </div>
                        <div class="row-item">
                            <el-form-item label="建议人姓名">
                                <el-input
                                    class="item-input"
                                    :maxlength="30"
                                    v-model.trim="searchForm.userName"
                                    @keyup.enter.native="search"
                                    placeholder="请输入"
                                ></el-input>
                            </el-form-item>
                        </div>
                        <div class="row-item">
                            <el-form-item label="建议人角色">
                                <key-value-select
                                    :isNeedAll="true"
                                    className="item-input"
                                    v-model.trim="searchForm.roleId"
                                    placeholder="请选择"
                                    dictUrl="/api/blade-platform/baseService/roleList"
                                    :dictProp="{
                                        data: 'result',
                                        label: 'roleName',
                                        value: 'id'
                                    }"
                                ></key-value-select>
                            </el-form-item>
                        </div>
                        <div class="row-item">
                            <el-form-item label="建议内容">
                                <el-input
                                    class="item-input"
                                    :maxlength="30"
                                    v-model.trim="searchForm.question"
                                    @keyup.enter.native="search"
                                    placeholder="请输入"
                                ></el-input>
                            </el-form-item>
                        </div>
                        <div class="row-item">
                            <el-form-item label="使用设备">
                                <el-select class="item-input" v-model="searchForm.useDevice" placeholder="请选择">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option
                                        v-for="item in facilityList"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="row-item">
                            <el-form-item label="品牌型号">
                                <el-input
                                    class="item-input"
                                    :maxlength="30"
                                    v-model.trim="searchForm.deviceType"
                                    @keyup.enter.native="search"
                                    placeholder="请输入"
                                ></el-input>
                            </el-form-item>
                        </div>
                        <div class="row-item">
                            <el-form-item label="软件版本">
                                <el-input
                                    class="item-input"
                                    :maxlength="30"
                                    v-model.trim="searchForm.deviceVersion"
                                    @keyup.enter.native="search"
                                    placeholder="请输入"
                                ></el-input>
                            </el-form-item>
                        </div>
                        <div class="row-item">
                            <el-form-item label="建议时间">
                                <el-date-picker
                                    style="width:216px"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    unlink-panels
                                    v-model="searchForm.time"
                                    type="datetimerange"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    align="right"
                                    ></el-date-picker>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="third-one">
            <div class="third-do-btn">
                <el-button class="do-btn-four" type="default" icon="el-icon-delete" @click="deleteItem(null)">删除</el-button>
                <div class="do-btn-right">
                    <div class="do-btn-check">
                        <el-checkbox class="btn-check-item" v-model="checked" @change="changeHign"></el-checkbox>
                        <span class="btn-check-span">显示高级功能</span>
                    </div>
                    <div class="do-btn-hign-list" v-if="checked">
                        <sort-data
                            :tableRow="tableRow"
                            @showList="getTableList"
                            sessionOriginalName="otherSortOrignalData_funcSuggestionBasicpage"
                            sessionResultName="otherSortData_funcSuggestionBasicpage"
                        ></sort-data>
                        <display-field
                            :selectList="tableRow"
                            sessionOriginalName="otherDisplayFiedOrignal_funcSuggestionBasicpage"
                            @setDataOrder="getDataOrder"
                            sessionResultName="otherDisplayFied_funcSuggestionBasicpage"
                        ></display-field>
                    </div>
                </div>
            </div>
            <div>
                <el-table
                    class="third-tableThree"
                    :data="tableData"
                    border
                    stripe
                    v-loading="tableLoading"
                    @selection-change="handleSelectionChange"
                    ref="faqSuggestTableData"
                    row-key="feedId">
                    <el-table-column type="selection" width="32px" :reserve-selection="true"></el-table-column>
                    <template v-for="(val,key) in tableDataShow">
                        <el-table-column
                            v-if="val.needKeyValue"
                            min-width="100px"
                            :prop="val.key"
                            :label="val.column"
                            :key="key"
                            :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <key-value-span :value="scope.row[val.key]" :dictUrl="val.actionUrl"></key-value-span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-else
                            min-width="100px"
                            :prop="val.key"
                            :label="val.column"
                            :key="key"
                            :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <span v-if="val.key === 'useDevice'">{{ scope.row[val.key] === 'web' ? webLabel : scope.row[val.key]}}</span>
                                <span v-else>{{ scope.row[val.key] }}</span>
                            </template>
                        </el-table-column>
                    </template>
                    <el-table-column label="操作">
                        <template slot-scope="{row}">
                            <el-button type="text" size="small" @click="todetail(row)">详情</el-button>
                            <span class="table-middle_line"></span>
                            <el-button type="text" size="small" @click="deleteItem(row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="third-page">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        background
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
            <!-- <fm-grid url="/api/blade-platform/serviceType/list" ref="serviceClassifyTypeTable">
                <template slot-scope="{rows,loading}">
                </template>
            </fm-grid> -->
		</div>
        <notice-modal
            :noticeModalVisible="noticeModal"
            @noticeModalClose="closeNotice"
            @noticeModalAgree="agreeNotice"
            :noticeTitle="noticeTitle"
            :noticeSpec="noticeSpec"
            :isError="isError"
            :noticeType="noticeType"
            :btnAgree="agreeContent"
            :noticeContent="noitceContent"
        ></notice-modal>
        <hign-modal
            :hignModalVisible="hignModal"
            @searchModal="toHignSearch"
            @cancelModal="closeModal"
            :hignOneList="tableRow"
        ></hign-modal>
    </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import { setStore, getStore } from "@/utils/store";

export default {
    name: "funcSuggestion_basicpage",

    data() {
        return {
            tableLoading: false,
            bmList: [], // 编码列表
            canNotClick: false, // 是否可以点击保存
            addTitle: '新增分类', // 新增弹窗名
            rulesImport: {
                sjklx: [
                    { required: true, message: "请选择", trigger: "change" }
                ],
                ljmc: [
                    { required: true, message: "请输入", trigger: "blur" }
                ],
                zjip: [
                    { required: true, message: "请输入", trigger: "blur" }
                ],
                dkh: [
                    { required: true, message: "请输入", trigger: "blur" }
                ],
                sjkm: [
                    { required: true, message: "请输入", trigger: "blur" }
                ],
                yhm: [
                    { required: true, message: "请输入", trigger: "blur" }
                ],
                pwd: [
                    { required: true, message: "请输入", trigger: "blur" }
                ],
            },
            ruleFormImport: {
                sjklx: 'Oracle', // 分类类型
                ljmc: '', // 连接名称
                zjip: '', // 主机ip
                dkh: '1521', // 端口号
                sjkm: '', // 分类名
                yhm: '', // 用户名
                pwd: '', // 密码
                bm: '', // 编码，默认自动
            },
            addModal: false, //
            isError: true, // 是否是错误提示
            noticeSpec: "分类删除后不可恢复，", // 标红提示
            noticeType: 1, // 提示类型
            agreeContent: "确定", // 提示弹窗确认按钮内容
            noticeTitle: "提示", // 提示
            noitceContent: "确定删除吗？", // 提示信息
            noticeModal: false, // 提示弹窗
            delectID: "", //删除一条数据的ID
            treeData: [
                {
                    label: '所有分类',
                    children: [],
                    show: false
                },
            ], // 树节点数据
            pageSize: 40,
            currentPage: 1,
            total: 0,
            tableData: [],
            hignModal: false, // 高级搜索
            searchForm: {
                keyId: '',
                userName: '',
                roleId: '',
                question: '',
                useDevice: '',
                deviceType: '',
                deviceVersion: '',
                time: '',
            },
            checked: true,
            checkClassList: [],
            checkID: "", //表格选中的ID
            hignSearchRes: "", // 高级检索条件
            orderConfig: "", // 字段展示和顺序需要的参数
            tableDataShow: [],
            countNum: 1, // 默认为1，以提醒第一个必填
            tableRow: [
                {
                    "column": "建议人账号",
                    "key": "keyId",
                    "needKeyValue": false,
                    "caseKey": "account"
                },
                {
                    "column": "建议人姓名",
                    "key": "userName",
                    "needKeyValue": false,
                    "caseKey": "real_name"
                },
                {
                    "column": "建议人角色",
                    "key": "userRoles",
                    "needKeyValue": false,
                    "caseKey": "role_name"
                },
                {
                    "column": "建议内容",
                    "key": "question",
                    "needKeyValue": false,
                    "caseKey": "question"
                },
                {
                    "column": "使用平台",
                    "key": "useType",
                    "needKeyValue": false,
                    "caseKey": "use_type"
                },
                {
                    "column": "使用设备",
                    "key": "useDevice",
                    "needKeyValue": false,
                    "caseKey": "use_device",
                    isCustomList: [
                        {
                        label: '厦门工学院智慧融合门户',
                        value: 'web'
                        },
                        {
                        label: 'iOS',
                        value: 'iOS'
                        },
                        {
                        label: '安卓',
                        value: 'Android'
                        }
                    ]
                },
                {
                    "column": "品牌型号",
                    "key": "deviceType",
                    "needKeyValue": false,
                    "caseKey": "device_type"
                },
                {
                    "column": "软件版本",
                    "key": "deviceVersion",
                    "needKeyValue": false,
                    "caseKey": "device_version"
                },
                {
                    "column": "建议时间",
                    "key": "createTime",
                    "needKeyValue": false,
                    "caseKey": "create_time"
                },
            ],
            selectData: '', // 选中分类
            apiServerDataBaseId: '', // 分类id
            deleteType: 1, // 删除类型，1分类，2单项列表删除，3批量删除, 4关闭
            deleteList: [],
            webLabel: null, // 使用设备的 web的名字 此处动态获取。
        };
    },
    async created() {
        const res = await this.$store.dispatch('getWebLabel');
        const [first] = res.data.result;
        this.webLabel = first.name;
        const dispField = this.getSessonValue("funcSuggestion_basicpage_DisplayFied");
        const tableRow = this.getSessonValue("funcSuggestion_basicpage_SortData");
        if (dispField) {
            this.orderConfig = dispField;
        }
        if (tableRow) {
            this.tableDataShow = tableRow;
        } else {
            this.tableDataShow = this.tableRow;
        }
        this.getSuggestionList();
        this.$store.dispatch('dictList');
    },
    computed: {
		...mapState({
            componentsName: state => state.robotsManage.robotsManageComponentName,
        }),
        facilityList() {
            const { dictList } = this.$store.state.serviceList;
            if (dictList && this.webLabel) {
                let list = dictList.filter(item => item.type === 7);
                list = list.map((item) => {
                    const el = item;
                    if (el.value === 'web') {
                        el.label = this.webLabel;
                    } else {
                        el.label = item.value;
                    }
                    return el;
                })
                return list
            }
            return [];
        },
	},
    methods: {
        ...mapMutations({
            changeComponentName: 'SET_robotsManageComponentName',
        }),
        ...mapActions([
            'proposeList',
            'proposeRemove',
        ]),
        todetail(data) {
            this.$emit('todetail', data)
        },
        handleSelectionChange(selection) {
            console.log(selection);
            this.checkClassList = [];
            for (var i = 0; i <= selection.length - 1; i++) {
                this.checkClassList.push(selection[i].feedId);
            }
            this.checkID = this.checkClassList.join(",");
        },
        // 高级检索
        toHignSearch(res) {
            // console.log(res)
            this.hignSearchRes = res;
            this.currentPage = 1;
            this.hignModal = false;
            this.getSuggestionList();
        },
        // 确认弹窗
        agreeNotice() {
            if (this.deleteType === 2) {
                this.faqRecordRemove(this.delectID)
            } else if (this.deleteType === 3) {
                console.log(this.checkID)
                this.faqRecordRemove(this.checkID)
            } else if (this.deleteType === 4) {
                this.noticeModal = false
            }
        },
        // 关闭弹窗
        closeNotice() {
            // console.log(111)
            this.delectID = "";
            this.noticeModal = false;
        },
        // 删除分类
        deleteDataBase() {
            this.deleteType = 1
            this.noticeSpec = '分类删除后不可恢复，' // 标红提示
            this.noticeType = 1, // 提示类型
            this.agreeContent = '确定' // 提示弹窗确认按钮内容
            this.noticeTitle = '提示' // 提示
            this.noitceContent = '确定删除吗？' // 提示信息
            this.noticeModal = true
        },
        // 删除
        deleteItem(row) {
            // console.log(row)
            this.noticeSpec = '' // 标红提示
            this.noticeType = 1, // 提示类型
            this.agreeContent = '确认' // 提示弹窗确认按钮内容
            this.noticeTitle = '确认操作' // 提示
            this.noitceContent = '是否确认删除？' // 提示信息
            if (!row) {
                if (this.checkClassList.length == 0) {
                    this.$message.error("请勾选数据");
                } else {
                    this.deleteType = 3
                    this.noticeModal = true
                }
            } else {
                this.delectID = row.feedId;
                this.deleteType = 2
                this.noticeModal = true;
            }
        },
        // 删除建议
        async faqRecordRemove(ids) {
            const {
                data: { msg, status }
            } = await this.proposeRemove({
                ids: ids,
            })
            if (status === 1000) {
                this.noticeModal = false
                this.$message.success("删除成功");
                this.$refs.faqSuggestTableData.clearSelection();
                this.checkClassList = [];
                this.delectID = '';
                this.getSuggestionList();
                return
            }
            this.$message.error(msg);
        },
        // 显示高级或者不显示
        changeHign() {
            console.log(this.checked);
        },
        // 关闭弹窗
        closeModal() {
            this.hignModal = false;
        },
        // 高级检索
        hignSearch() {
            this.hignModal = true;
        },
        //条数变化
        handleSizeChange(val) {
            this.currentPage = 1;
            this.pageSize = val;
            this.getSuggestionList();
        },
        //页码变化
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getSuggestionList();
        },
        search() {
            this.hignSearchRes = "";
            this.currentPage = 1;
            this.getSuggestionList();
        },
        getTableList(value) {
            this.tableDataShow = value;
        },
        getDataOrder(value) {
            this.orderConfig = value;
            this.getSuggestionList();
        },
        getSessonValue(name) {
            return getStore({
                name: name,
                type: "session"
            });
        },
        //表单重置
        reset(formName) {
            this.$refs[formName].resetFields();
            this.$refs.faqSuggestTableData.clearSelection();
            this.checkClassList = [];
            console.log("重置",this.searchForm)
            this.searchForm.keyId = ''
            this.searchForm.userName = ''
            this.searchForm.roleId = ''
            this.searchForm.question = ''
            this.searchForm.useDevice = ''
            this.searchForm.deviceType = ''
            this.searchForm.deviceVersion = ''
            this.searchForm.time = ''
            this.search()
        },
        //获取列表
        async getSuggestionList() {
            let dataSortStr = this.orderConfig;
            if (Array.isArray(this.orderConfig)) {
                dataSortStr = this.orderConfig.join(",");
            }
            this.tableLoading = true
            const getSuggestionList = await this.$store.dispatch('proposeList', [{
                    current: this.currentPage,
                    size: this.pageSize,
                },
                {
                    keyId: this.searchForm.keyId,
                    userName: this.searchForm.userName,
                    roleId: this.searchForm.roleId,
                    useDevice: this.searchForm.useDevice,
                    question: this.searchForm.question,
                    deviceType: this.searchForm.deviceType,
                    deviceVersion: this.searchForm.deviceVersion,
                    minTime: this.searchForm.time?this.searchForm.time[0]:'',
                    maxTime: this.searchForm.time?this.searchForm.time[1]:'',
                    advancedSearch: this.hignSearchRes,
                    dataSortStr: dataSortStr,
                }]
            );
            this.tableLoading = false
            console.log(getSuggestionList)
            if (getSuggestionList.data.status === 1000) {
                if (getSuggestionList.data.result.records.length !== 0) {
                    this.tableData = getSuggestionList.data.result.records;
                    this.total = getSuggestionList.data.result.total;
                } else {
                if (this.currentPage !== 1) {
                    this.currentPage -= 1
                    this.getSuggestionList()
                } else {
                    this.tableData = []
                    this.total = 0
                }
                }
            } else {
                this.tableData = []
                this.total = 0
            }
        },
    }
};
</script>

<style lang='scss'>
.faq-suggestion-basicpage {
    .node-delete, .node-edit {
        opacity: 0;
    }
    .el-tree-node__content:hover .node-delete {
        opacity: 1;
    }
    .el-tree-node__content:hover .node-edit {
        opacity: 1;
    }
    .el-tree-node .is-current > .el-tree-node__content {
        .node-delete {
            opacity: 1;
        }
        .node-edit {
            opacity: 1;
        }
    }
    .tableThree-height-shu {
        display: inline-block;
        padding: 0 4px;
        position: relative;
        .shu-item {
            position: absolute;
            width: 1px;
            height: 12px;
            background-color: #d4d4d7;
            display: inline-block;
            top: -10px;
        }
    }
    .left-tree {
        height: calc(100vh - 204px) !important;
    }
    .el-table__body-wrapper {
        height: calc(100vh - 236px) !important;
    }
    .custom-tree_tab {
        font-size: 12px;
        width: 100% !important;
        text-align: left !important;
        padding: 0 8px;
        cursor: default !important;
    }
}
.dic-modal {
	.el-dialog__body {
		height: auto;
	}
}
</style>
